// Constants
import { SELECT_IBAN_INPUT_PROPS } from '../constants/iban-selector.component.constants';
// Translations
import { ERROR_MESSAGE, LABEL, PLACEHOLDER } from '../translations/iban-selector.translations';
// Types
import { IbanListType } from '../types/iban-list.type';
import { InputDropdownType } from '@openbank/ziniaweb-ui-components';
import {
  GetIbanInputConfigurationType,
  MapAccountsToOptionsReturnType,
} from './types/iban-selector.configurations.type';
// Utils
import { formatIban } from '@openbank/cf-ui-framework';
import { getSelectedIbanValue } from '../utils/iban-selector.utils';

const mapAccountsToOptions = (ibanList: IbanListType): MapAccountsToOptionsReturnType =>
  ibanList.map(account => ({
    label: formatIban({ iban: account.iban }),
    value: account.iban,
    selected: account.selected,
  }));

const getIbanInputConfiguration = ({
  formatMessage,
  ibanList,
  handleChangeIban,
}: GetIbanInputConfigurationType): InputDropdownType => ({
  ...SELECT_IBAN_INPUT_PROPS,
  errorMessage: formatMessage({ id: ERROR_MESSAGE }),
  label: formatMessage({ id: LABEL }),
  placeholder: formatMessage({ id: PLACEHOLDER }),
  optionList: { options: mapAccountsToOptions(ibanList) },
  onChange: handleChangeIban,
  value: getSelectedIbanValue(ibanList),
});

export { getIbanInputConfiguration, mapAccountsToOptions };
